// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2ljTZ","content":"styles_content__1CrVx","selectAll":"styles_selectAll__cmt3I"};